import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import ForecastTemporalView from './ForecastTemporalView';
import ForecastMapContainer from '../components/forecast_metrics-components/ForecastMapContainer.js';
import MetricsBelowMap from '../components/forecast_metrics-components/metrics_below_map.js';
import ForecastButtonsContainer from '../components/forecast_metrics-components/ForecastButtonsContainer.js';
import TimeSliderForecastMetric from '../components/sliders/slider_forecast_metric.js';
import TimeSliderForecastMetric_00625 from '../components/sliders/slider_forecast_metric_00625.js';
import { FORECAST_METRICS_CONFIG } from '../config/forecastMetrics.js';
import MapIcon from '@mui/icons-material/Map';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import LoopIcon from '@mui/icons-material/Loop';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useNavigate } from 'react-router-dom';
import SlidingModal from '../components/common/SlidingModal';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';


const useIsTouchDevice = () => {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const detector = () => {
      // 'pointer: coarse' es TRUE solo si el dispositivo principal es el dedo (iPad/Móvil)
      // Si hay un mouse conectado y es el principal, esto devuelve FALSE
      return window.matchMedia('(pointer: coarse)').matches;
    };

    setIsTouch(detector());

    // Escuchar cambios (por si desconectan el mouse del iPad)
    const watcher = window.matchMedia('(pointer: coarse)');
    const listener = (e) => setIsTouch(e.matches);
    watcher.addEventListener('change', listener);
    return () => watcher.removeEventListener('change', listener);
  }, []);

  return isTouch;
};
const ForecastMapView = ({
  prettyModelName,
  issueTime,
  cqlSevere,
  cqlFecha,
  mapLeftLayer,
  weekNumber,
  selectedTime,
  mapRightLayer,
  selectedModel,
  metricsName,
  cqlFechaMax,
  cqlFechaMin,
  issueTimeOptions,
  handleDateChange,
  handleModelClick,
  handleRiskClick,
  handleDateSelect,
  handleTimeSelect,
  handleBackdropOpen,
  handleBackdropClose,
  setIssueTimeOptions,
  showMapView,
  setShowMapView,
  forecastState = {},
}) => {

  React.useEffect(() => {
    const originalStyle = document.body.style.overflow;

    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalStyle;
      document.body.style.margin = '';
      document.body.style.padding = '';
    };
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFullWidth, setIsFullWidth] = useState(false);
  const [showIcons, setShowIcons] = useState(true);
  const isTouch = useIsTouchDevice();
  const navigate = useNavigate();


  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen) {
      setIsFullWidth(false);
    }
  };

  const toggleFullWidth = () => {
    setIsFullWidth(!isFullWidth);
  };

  const isHighResLayer = selectedModel && selectedModel.includes('euro_1k_00625_15m');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Box sx={{
      position: 'relative',
      width: '100%',
      margin: 0,
      padding: 0,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      boxSizing: 'border-box',
      '& *': {
        boxSizing: 'border-box',
      }
    }}>
      {/* Header */}
      <Box sx={{
        width: '100%',
        height: '60px',
        backgroundColor: '#161616',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
        boxSizing: 'border-box',
        overflow: 'hidden',
        zIndex: 1300,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0
      }}>
        <a href="https://www.aimethods.com/" target="_blank" rel="noopener noreferrer" style={{ height: '80%' }}>
          <img
            src="/images/AIMethods_logo.png"
            alt="AI Methods"
            style={{
              height: '100%',
              objectFit: 'contain',
              filter: 'brightness(0) invert(1)'
            }}
          />
        </a>

        <a href="https://www.sesarju.eu/" target="_blank" rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexShrink: 0,
            maxWidth: 'clamp(120px, 30vw, 240px)',
            height: 'auto',
          }}
        >
          <img
            src="/images/KAIROS-supportedby_white.svg"
            alt="KAIROS supported by"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '91px',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </a>
      </Box>

      <Box sx={{
        flex: '1 1 auto',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        
        boxSizing: 'border-box',
        paddingTop: '60px'
      }}>
        <Box sx={{
          flex: '1 1 auto',
          width: '100%',
          position: 'relative',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px #161616',
          
          
        }}>
          <ForecastMapContainer
            prettyModelName={prettyModelName}
            issueTime={issueTime}
            cqlSevere={cqlSevere}
            cqlFecha={cqlFecha}
            mapLeftLayer={mapLeftLayer}
            weekNumber={weekNumber}
            selectedTime={selectedTime}
            mapRightLayer={mapRightLayer}
            selectedModel={selectedModel}
            metricsName={metricsName}
          />

          <Box sx={{
            position: 'relative',
            width: '100%',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
          }}>

            <SlidingModal
              isOpen={isModalOpen}
              isFullWidth={isFullWidth}
              onToggleWidth={toggleFullWidth}
            >
              <ForecastTemporalView
                cqlFecha={cqlFecha}
                cqlFechaMax={cqlFechaMax}
                cqlFechaMin={cqlFechaMin}
                issueTime={issueTime}
                cqlSevere={cqlSevere}
                weekNumber={weekNumber}
                metricsName={metricsName}
                issueTimeOptions={issueTimeOptions}
                selectedTime={forecastState.selectedTime}
                handleRiskClick={handleRiskClick}
                mapLeftLayer={mapLeftLayer}
                handleDateChange={handleDateChange}
                handleModelClick={handleModelClick}
                selectedModel={selectedModel}
              />
            </SlidingModal>
          </Box>
        </Box>
      </Box>





      <Box sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        gap: { xs: '12px', sm: '10px' },
        width: '100%',
        padding: '16px',
        backgroundColor: '#161616',
        boxSizing: 'border-box',
        boxShadow: '0 -4px 10px rgba(0,0,0,0.3)',
        zIndex: 1100,
        height: { xs: 'auto', sm: '80px' },
        minHeight: { xs: '150px', sm: '80px' },
        pb: { xs: 'safe-area-inset-bottom', sm: '16px' }, // Safari iOS safe area
        overflow: 'visible',
        '& > *': {
          margin: 0,
          flexShrink: 0,
        },



        // 1. Bloque de Selectores (Ahora es el hijo 2)
        '& > *:nth-child(1)': {
          flex: '0 0 auto',
          width: { xs: '400px', sm: '100px', md: '30%' ,lg:'45%'},
          minWidth: '10px',
        },

        // 2. Bloque del Slider (Ahora es el hijo 3)
        '& > *:nth-child(2)': {
          flex: '1 1 auto',
          minWidth: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start',
        },

        // 3. Bloque de Botones Live (Ahora es el hijo 4)
        '& > *:nth-child(3)': {
          flex: '0 0 auto',
          minWidth: 'fit-content',
        }
      }}>

        {/* --- LA SOLAPA: Este es el nuevo primer hijo --- */}
        {/* <Box sx={{
          position: 'absolute',
          bottom: isMenuOpen
            ? '100%'
            : (isTouch ? (showIcons ? '100%' : '100%') : '100%'),
          left: '50%',
          transformOrigin: 'bottom center',
          // Empieza en 0.5 según tu código
          transform: isMenuOpen
            ? 'translateX(-50%) scale(0.7)' // Se queda crecida si el menú está abierto
            : (isTouch
              ? (showIcons ? 'translateX(-50%) scale(0.7)' : 'translateX(-50%) scale(0.5)')
              : 'translateX(-50%) scale(0.5)'),
          
          width: '1130px',
          height: '60px',
          maxWidth: '100vw',
          display: 'block',
          '@media (max-width: 1040px)': {
            display: 'none',
          },
          flexDirection: 'column',
          overflow: 'visible',
          transition: 'all 0.3s ease-in-out',
          opacity: 1,
          visibility: 'visible',
          pointerEvents: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          backdropFilter: 'blur(10px)',


          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',


          boxShadow: '0 -4px 10px rgba(0,0,0,0.2)',


          padding: '10px 30px 0px 30px',

          // Opcional: Para el efecto de "curva suave" hacia los lados:
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            width: '20px',
            height: '20px',
            display: { xs: 'none', sm: 'block' } // Solo en pantallas más grandes
          },
          '&::before': {
            left: '-19px', // En lugar de -20px, lo movemos 1px a la derecha
            background: 'radial-gradient(circle at 0 0, transparent 20px, #1a1a1c 21px)',
          },
          '&::after': {
            right: '-19px', // En lugar de -20px, lo movemos 1px a la izquierda
            background: 'radial-gradient(circle at 100% 0, transparent 20px, #1a1a1c 21px)',
          },
          '&:hover, &:focus-within': {
            bottom: !isTouch ? '100%' : (showIcons ? '109%' : '100%'),
            transform: !isTouch ? 'translateX(-50%) scale(0.7)' : (showIcons ? '100%' : '100%'),
          },

          filter: 'drop-shadow(0 -4px 12px rgba(0,0,0,0.4))',
          pointerEvents: 'auto',
        }}>
          <MetricsBelowMap
            onMenuOpen={() => setIsMenuOpen(true)}
            onMenuClose={() => setIsMenuOpen(false)}
            metricsNames={metricsName}
            cqlFecha={cqlFecha}
            weekNumber={weekNumber}
            issueTime={issueTime}
            cqlSevere={cqlSevere}
            handleRiskClick={handleRiskClick}

          />
        </Box> */}

        {/* CONTENEDOR DE SELECTORES */}
        <Box sx={{
          borderRadius: 1,
          overflow: 'visible',
          width: '40%', // <--- CAMBIO 4: De 40% a auto
          height: 'fit-content',
          marginBottom: { xs: '14px', sm: '0px' }
        }}>
          <ForecastButtonsContainer
            cqlFecha={cqlFecha}
            selectedModel={selectedModel}
            cqlFechaMax={cqlFechaMax}
            cqlFechaMin={cqlFechaMin}
            issueTimeOptions={issueTimeOptions}
            issueTime={issueTime}
            onDateChange={handleDateChange}
            onModelClick={handleModelClick}
            onDateSelect={handleDateSelect}
            onTimeSelect={handleTimeSelect}
            onBackdropOpen={handleBackdropOpen}
            onBackdropClose={handleBackdropClose}
            setIssueTimeOptions={setIssueTimeOptions}
          />
        </Box>

        {/* CONTENEDOR DEL SLIDER */}
        <Box sx={{
          borderRadius: 1,
          padding: '2px 14px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          boxSizing: 'border-box',
          justifyContent: 'flex-end',

        }}>
          {isHighResLayer ? (
            <TimeSliderForecastMetric_00625
              key={`slider-00625-${issueTime}`}
              initialDate={cqlFechaMin}
              steps={96}
              onChange={handleDateChange}
              cqlFechaMin={cqlFechaMin}
              issueTime={issueTime}
            />
          ) : (
            <TimeSliderForecastMetric
              key={`slider-normal-${issueTime}`}
              initialDate={cqlFechaMin}
              steps={FORECAST_METRICS_CONFIG.SLIDER_STEPS}
              onChange={handleDateChange}
              cqlFechaMin={cqlFechaMin}
              issueTime={issueTime}
            />
          )}
        </Box>

        {/* BLOQUE DE BOTONES (Live Forecast e Icono) */}
        <Box sx={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}>
          <IconButton
            onClick={toggleModal}
            sx={{
              color: "#fff",
              borderColor: '#14599e',
              borderWidth: 2,
              borderStyle: 'solid',
              backgroundColor: isModalOpen ? "rgba(46, 46, 46, 0.8)" : "#161616",
              backdropFilter: 'blur(16px)',
              '&:hover': { transform: 'scale(1.1)', borderColor: '#14599e' },
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              transform: isModalOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            title={isModalOpen ? "Hide graph panel" : "Display graph panel"}
          >
            {isModalOpen ? <LoopIcon fontSize="large" /> : <AutoGraphIcon fontSize="large" />}
          </IconButton>
          <Button
            component="a"
            onClick={() => navigate('/weather-map')}
            startIcon={<MapIcon />}
            variant="contained"
            color="secondary"
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '0.75rem',
              margin: 0,
              whiteSpace: 'nowrap',
              minWidth: '140px',
              flexShrink: 0,
              borderRadius: 2,
              boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
              px: 2,
              py: 1,
              backgroundColor: 'rgba(35, 155, 105, 0.85)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: '1px solid rgba(255, 255, 255, 0.25)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                backgroundColor: 'rgba(28, 124, 84, 1)',
                boxShadow: '0 16px 48px rgba(35, 155, 105, 0.5)',
                transform: 'translateY(-2px)',
                borderColor: 'rgba(255, 255, 255, 0.4)'
              },
            }}
          >
            Live Forecast
          </Button>
        </Box>
        {/*buttom  <Box sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1102,
          transition: 'bottom 0.3s ease-in-out',
          display: isTouch
            ? 'block'
            : 'none',
          '@media (max-width: 1040px)': {
            display: isTouch ? 'none' : 'none', // Se oculta en móvil si es touch
          },
          bottom: {
            sm: showIcons ? 'calc(100% + 90px)' : 'calc(100% + 25px)',
            md: showIcons ? 'calc(100% + 90px)' : 'calc(100% + 25px)',
            xs: '72%',
          },
        }}>
          <IconButton
            onClick={() => setShowIcons(!showIcons)}
            sx={{
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              color: 'white',
              '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.8)', transform: 'scale(1.2)' },
              transition: 'all 0.2s ease',
              border: '1px solid rgba(255,255,255,0.2)'
            }}
          >
            {showIcons ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
          </IconButton>
        </Box> */}
      </Box>
    </Box >
  );
};

export default ForecastMapView;
